<template>
    <div class="vx-col md:w-full sm:w-auto">

        <vx-tooltip :text="$t('button.edit')" position="top">
            <feather-icon icon="EditIcon" class="action-success mr-4"
                svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord" />
        </vx-tooltip>

        <vx-tooltip :text="$t('button.delete')" position="top" v-if="isPermissionDeleteServicePacks">
            <feather-icon icon="TrashIcon" class="action-err " svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                @click="confirmDeleteRecord" />
        </vx-tooltip>
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../../store/permission";
import {constAPI, constRouter} from "../../../../../store/constant";

export default {
    name: 'CellRendererActions',

    created() {},

    methods: {
        editRecord() {
            this.$router.push(`/user/info-service-packs?id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                title: 'Xác nhận xóa',
                type: 'confirm',
                color: 'danger',
                text: 'Bạn có chắc chắn muốn xóa dịch vụ '+ `"${this.params.data.name}"?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.get(`/beauty-service-package/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_VIP_CUSTOMER', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xóa dịch vụ thành công!',
                iconPack: 'feather',
                icon: 'icon-check-circle',
            })
        },

        isPermissionDeleteServicePacks() {
            return isAPI(this, constAPI.beauty_service_pack_delete);
        },
    }
}
</script>
